import { SurveyAnswerOkStatus, SurveyAnswerStatus, getAllThemeQuestions } from "../amorg-common";

type AnswerUnavailableView = { name:'unavailable' };
type AnswerIntroductionView = { name:'introduction', answerStatus:SurveyAnswerOkStatus };
type AnswerSegmentationView = { name:'segmentation', answerStatus:SurveyAnswerOkStatus };
type AnswerQuestionView = { name:'question',answerStatus:SurveyAnswerOkStatus, questionIndex:number };
type AnswerDoneView = { name:'done' };

export type AnswerView = 
    AnswerUnavailableView | 
    AnswerIntroductionView | 
    AnswerSegmentationView | 
    AnswerQuestionView | 
    AnswerDoneView;

export const answerStateMachine = (answerStatus:SurveyAnswerStatus) => 
{
    return {

        initializeView: ():AnswerUnavailableView | AnswerIntroductionView | AnswerSegmentationView | AnswerQuestionView =>
        {
            if(answerStatus.status === 'error' || answerStatus.status === 'unavailable')
                return { 
                    name:'unavailable' 
                };

            if(answerStatus.lastAction === undefined)
                return { 
                    name:'introduction',
                    answerStatus
                };

            if(answerStatus.lastAction.name === 'segments'){
                return { 
                    name:'question',
                    answerStatus,
                    questionIndex: 0 
                };
            }

            const allQuestions = getAllThemeQuestions(answerStatus.survey.themes);

            // returns intro if last last action was last question
            return answerStatus.lastAction.questionIndex === allQuestions.length-1
                ? { 
                    name:'introduction',
                    answerStatus
                }
                : { 
                    name:'question',
                    answerStatus,
                    questionIndex: answerStatus.lastAction.questionIndex + 1
                };
        },

        clickIntroductionNext: ():AnswerUnavailableView | AnswerIntroductionView | AnswerSegmentationView | AnswerQuestionView => 
        {
            if(answerStatus.status !== 'ok')
                return { 
                    name:'unavailable'
                }

            if(answerStatus.survey.segmentations.length === 0){
                return { 
                    name:'question',
                    answerStatus,
                    questionIndex: 0
                };
            }
            else
                return { 
                    name:'segmentation',
                    answerStatus
                };
        },

        submittedSegments: (): AnswerQuestionView | AnswerUnavailableView =>
        {
            if(answerStatus.status !== 'ok' )
                return { 
                    name:'unavailable' 
                };

            return { 
                name:'question',
                answerStatus,
                questionIndex: 0
            };
        },

        questionSubmitted: (): AnswerQuestionView | AnswerDoneView | AnswerUnavailableView =>
        {
            if(answerStatus.status !== 'ok' || answerStatus.lastAction === undefined)
                return { 
                    name:'unavailable' 
                };

            if(answerStatus.lastAction.name !== 'question')
                throw new Error('Can not click previous unless OK status');
                
            const questions = getAllThemeQuestions(answerStatus.survey.themes);
            
            if(answerStatus.lastAction.questionIndex === questions.length-1)
                return { 
                    name:'done' 
                };

            return { 
                name:'question', 
                answerStatus,
                questionIndex: answerStatus.lastAction.questionIndex + 1
            };
        },

        clickPrevious: (currentView:AnswerView):AnswerView => 
        {
            if(answerStatus.status !== 'ok' )
                throw new Error('Can not click previous unless OK status');

            if(currentView.name === 'segmentation')
                return { 
                    name:'introduction',
                    answerStatus
                };

            if(currentView.name === 'question'){
                if(currentView.questionIndex === 0){
                    if(answerStatus.survey.segmentations.length === 0)
                        return { 
                            name:'introduction',
                            answerStatus
                        };
                    else
                        return { 
                            name:'segmentation',
                            answerStatus
                        };
                }
                else{
                    return { 
                        name:'question', 
                        answerStatus,
                        questionIndex: currentView.questionIndex -1
                    };
                }
            }

            return { 
                name:'unavailable' 
            };
        }
    };
}